import { createFileRoute } from '@tanstack/react-router'
import { SubPane } from './-components/dev/transition-playground'

export const Route = createFileRoute('/_app/dev-resources/transitions/one/item/gamma/x')({
  component: () => <SubPane parent="Gamma" name="X" />,
})
